import { Routes } from '@angular/router';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { authGuard } from './core/guards/auth.guard';
import { pendingChangesGuard } from './core/guards/pending-changes.guard';
import { cryptoGuard } from './core/guards/crypto.guard';
import { setupCompletedGuard } from './core/guards/setup-completed.guard';

export const routes: Routes = [
    // Public routes (only accessible when NOT logged in)
    {
        path: '',
        loadComponent: () => import('./auth/components/signin-new/signin-shell/signin-shell.component').then(m => m.SigninShellComponent),
        title: 'GaulBridge | Track & Manage Your Money',
        canActivate: [noAuthGuard]
    },
    {
        path: 'register',
        loadComponent: () => import('./auth/components/signup/signup-shell/signup-shell.component').then(m => m.SignupShellComponent),
        title: 'GaulBridge | Track & Manage Your Money',
        canActivate: [noAuthGuard],
        canDeactivate: [pendingChangesGuard]
    },
    {
        path: 'forgot-password',
        loadComponent: () => import('./auth/components/forgot-password/forgot-password-shell/forgot-password-shell.component').then(m => m.ForgotPasswordShellComponent),
        title: 'GaulBridge | Track & Manage Your Money',
        canActivate: [noAuthGuard]
    },
    {
        path: 'kyc-pending',
        loadComponent: () => import('./auth/components/signup/pages/step-kyc-pending/step-kyc-pending.component').then(m => m.StepKycPendingComponent),
        title: 'GaulBridge | Track & Manage Your Money',
        canActivate: [authGuard],
    },
    // Authenticated routes inside Layout
    {
        path: '',
        loadComponent: () => import('./shared/components/layout/layout').then(m => m.Layout),
        canActivate: [authGuard],
        children: [
            {
                path: 'dashboard',
                loadComponent: () => import('./components/dashboard/dashboard-shell/dashboard-shell').then(m => m.DashboardShell),
                title: 'GaulBridge | Your global finance dashboard',
                canActivate: [setupCompletedGuard]
            },
            {
                path: 'accounts',
                loadComponent: () => import('./components/accounts/accounts-shell/accounts-shell.component').then(m => m.AccountsShellComponent),
                title: 'GaulBridge | Your Accounts',
                canActivate: [setupCompletedGuard]
            },
            {
                path: 'account-details',
                loadComponent: () => import('./components/accounts/pages/account-details/account-details').then(m => m.AccountDetails),
                title: 'GaulBridge | Account Details',
                canActivate: [setupCompletedGuard]
            },
            {
                path: 'cards',
                loadComponent: () => import('./components/cards/cards').then(m => m.Cards),
                title: 'GaulBridge | Your Cards',
                canActivate: [setupCompletedGuard]
            },
            {
                path: 'transactions',
                loadComponent: () => import('./components/transactions/transactions').then(m => m.Transactions),
                title: 'GaulBridge | Your Transactions',
                canActivate: [setupCompletedGuard]
            },
            {
                path: 'transactions/list',
                loadComponent: () => import('./components/transactions/components/transaction-list/transaction-list').then(m => m.TransactionList),
                title: 'GaulBridge | Your Transactions History'
            },
            {
                path: 'transactions/view/:id',
                loadComponent: () => import('./components/transactions/components/transaction-view/transaction-view').then(m => m.TransactionView),
                title: 'GaulBridge | Your Transaction Details'
            },
            {
                path: 'transaction-details',
                loadComponent: () => import('./components/transactions/components/transaction-details/transaction-details').then(m => m.TransactionDetails),
                title: 'GaulBridge | Your Transaction Details'
            },
            {
                path: 'kyc-verification',
                loadComponent: () => import('./components/kyc-verification/kyc-verification').then(m => m.KycVerification),
                title: 'GaulBridge | KYC Verification',
                canDeactivate: [pendingChangesGuard]
            },
            {
                path: 'security',
                loadComponent: () => import('./components/sessions-security/sessions-security').then(m => m.SessionsSecurity),
                title: 'GaulBridge | Security'
            },
            {
                path: 'support',
                loadComponent: () => import('./components/support-chat/support-chat').then(m => m.SupportChat),
                title: 'GaulBridge | Support'
            },
            {
                path: 'crypto-details',
                loadComponent: () => import('./components/crypto/pages/crypto-details/crypto-details').then(m => m.CryptoDetails),
                title: 'GaulBridge | Crypto Details'
            },
            {
                path: 'crypto',
                loadComponent: () => import('./components/crypto/crypto-shell/crypto-shell.component').then(m => m.CryptoShellComponent),
                title: 'GaulBridge | Crypto',
                canActivate: [setupCompletedGuard, cryptoGuard]
            },
            {
                path: 'settings',
                loadComponent: () => import('./components/settings/settings').then(m => m.Settings),
                title: 'GaulBridge | Settings'
            }
        ]
    },
    // Wildcard: any unknown/invalid URL renders a lightweight component that
    // records the originally requested URL for tracking, then navigates to the
    // application root. A plain `redirectTo: ''` would rewrite the URL before
    // navigation tracking could observe it, recording invalid visits as '/' or
    // '/dashboard'. From '' the noAuthGuard renders the signin page
    // (logged-out) or forwards to /dashboard (logged-in), so no loop occurs.
    {
        path: '**',
        loadComponent: () => import('./core/components/unknown-route-redirect/unknown-route-redirect.component').then(m => m.UnknownRouteRedirectComponent)
    }
];
